// @mui
import { styled } from "@mui/material/styles"

// ----------------------------------------------------------------------

export const StyledRoot = styled("div")(() => ({
  height: "100%",
  display: "flex",
  position: "relative",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center top",
  backgroundSize: "cover",
}))
